import React from "react";
import { pctToColor } from "@/lib/handball";

/**
 * 9-grid goal visualization.
 * Ruta 1 = uppe till vänster, Ruta 9 = nere till höger
 * If `onSelect` provided, cells become selectable (input mode).
 * `stats` is optional: { "1": { total, saves, save_pct }, ... }
 */
export default function GoalGrid({
  placement,
  onSelect,
  stats,
  selectable = false,
  showEmpty = false,
  testIdPrefix = "goal-cell",
  testId = "goal-grid",
  hideFrame = false,
}) {
  const cells = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div
      className={hideFrame ? "" : "goal-frame"}
      data-testid={testId}
      style={hideFrame ? { width: "100%", height: "100%" } : undefined}
    >
      <div
        className="grid grid-cols-3 gap-[2px] net-line"
        style={hideFrame ? { width: "100%", height: "100%" } : undefined}
      >
        {cells.map((n) => {
          const cellStats = stats?.[String(n)];
          const total = cellStats?.total ?? 0;
          const saves = cellStats?.saves ?? 0;
          const savePct = cellStats?.save_pct ?? 0;
          const { bg, fg } =
            selectable || showEmpty
              ? { bg: "#1A1A1A", fg: "#A1A1AA" }
              : pctToColor(savePct, total);

          const isSelected = selectable && placement === n;

          return (
            <button
              type="button"
              key={n}
              data-testid={`${testIdPrefix}-${n}`}
              data-selected={isSelected}
              onClick={selectable ? () => onSelect?.(n) : undefined}
              className={`goal-cell ${selectable ? "selectable" : ""}`}
              style={{
                background: selectable
                  ? isSelected
                    ? "#34C759"
                    : "#141414"
                  : bg,
                color: selectable ? "#ffffff" : fg,
                cursor: selectable ? "pointer" : "default",
              }}
            >
              <span className="cell-num" style={{ color: selectable ? "#A1A1AA" : fg }}>
                {n}
              </span>
              {!selectable && total > 0 && (
                <>
                  <span
                    className="font-display font-black leading-none"
                    style={{ fontSize: "clamp(1.4rem, 3vw, 2.4rem)" }}
                  >
                    {Math.round(savePct)}%
                  </span>
                  <span
                    className="font-display font-semibold mt-1 tracking-widest"
                    style={{ fontSize: "0.75rem", opacity: 0.75 }}
                  >
                    {saves}/{total}
                  </span>
                </>
              )}
              {!selectable && total === 0 && (
                <span
                  className="font-display font-bold text-zinc-600"
                  style={{ fontSize: "0.75rem", letterSpacing: "0.15em" }}
                >
                  INGEN DATA
                </span>
              )}
              {selectable && (
                <span
                  className="font-display font-black"
                  style={{
                    fontSize: "clamp(1.6rem, 4vw, 2.6rem)",
                    color: isSelected ? "#062712" : "#3F3F46",
                  }}
                >
                  {n}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
